import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { PaymentRequest } from '../paymentrequest.model';
import { PaymentrequestService } from '../paymentrequest.service';

@Component({
  selector: 'app-paymentrequestlst',
  templateUrl: './paymentrequestlst.component.html',
  styleUrls: ['./paymentrequestlst.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("ModalConfirmReject")
  },
})
export class PaymentrequestlstComponent implements OnInit {

  lstPaymentReq: PaymentRequest[] = [];
  displayedColumns: string[] = ['id', 'serviceClass', 'fullName', "createDate", "view"];
  dataSource!: MatTableDataSource<PaymentRequest>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  PaymentReq: PaymentRequest = {} as PaymentRequest;
  status: { id: number, name: string }[] = [];
  selectedStatus: number = 1
  viewReq: boolean = false;
  rejectReason: string = "";
  pageSize = 100;

  constructor(private service: PaymentrequestService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globle: Globle,
    private translate: TranslateService) { }

  ngOnInit() {

    this.status = [
      { id: 0, name: 'onRequest' },
      { id: 1, name: "onProccess" },
      { id: 2, name: "orderDone" },
      { id: 3, name: "rejected" }
    ];

    this.selectedStatus = 0;
    this.pageSize = this.globle.pageSize;
    this.get();
    setInterval(() => this.get(), 300000);
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedStatus).subscribe(data => {
      this.lstPaymentReq = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.lstPaymentReq);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  view(item: any) {
    this.PaymentReq = item;
    this.viewReq = true;
  }

  onDelete(id: number) {
    this.PaymentReq.id = id;
    this.openDialog();
  }

  refresh() {
    this.selectedStatus = 0;
    this.get();
  }

  back() {
    this.viewReq = false;
    this.PaymentReq = {} as PaymentRequest;
  }
  // delete() {
  //   this.spinnerOverlay = true;
  //   this.dialog.closeAll();
  //   this.service.Delete(this.category.id).subscribe(data => {
  //     this.openSnackBar(this.translate.instant("deletedSuccessfully"),'snackBarSuccess');
  //     this.spinnerOverlay = false;
  //     this.getCategory();
  //   },
  //     error => {
  //       console.log(error);
  //       this.spinnerOverlay = false;
  //       this.dialog.closeAll();
  //       if (error.error.message) {
  //         this.openSnackBar(error.error.message, "snackBarError");
  //       }
  //       else {
  //         this.openSnackBar("Internal server error", "snackBarError");
  //       }
  //     })
  // }

  confirmDelete() {
    //this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogReject(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange() {
    this.get();
  }

  accept() {
    let obj = {
      "id": this.PaymentReq.id,
      "status": 1,
      "rejectReasons": ""
    }
    this.update(obj);
  }

  onReject() {
    this.openDialogReject();
  }

  confirmReject() {
    let obj = {
      "id": this.PaymentReq.id,
      "status": 3,
      "rejectReasons": this.rejectReason
    }
    this.update(obj);
    this.dialog.closeAll();
  }

  onRequestDone() {
    let obj = {
      "id": this.PaymentReq.id,
      "status": 2,
      "rejectReasons": ""
    }
    this.update(obj);
  }

  update(object: any) {
    this.spinnerOverlay = true;
    this.service.Update(object).subscribe(data => {
      this.openSnackBar(this.translate.instant("operationSuccessfully"), 'snackBarSuccess');
      this.back();
      this.get();
    }, error => {
      this.openSnackBar("Internal server error", 'snackBarError');
      console.log(error)
    });
  }

}
